import { Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NavParams, ViewController } from "ionic-angular";
import { Action } from "models/order-management/action";
import { ESignedAction } from "models/order-management/eSignedAction";
import CredentialedResource from "models/resource-management/credentialed-resource";
import * as moment from "moment-timezone";
import { OrderManagementDataService } from "providers/order-management-data-service/order-management-data-service";
import { StateManagementService } from "providers/state-management/state-management.service";
import { OrderIdAndSignatureRequest } from "../provider-panel";

@Component({
  selector: "e-sign-selected-orders",
  templateUrl: "e-sign-selected-orders.html",
})
export class ESignSelectedOrdersPopup {
  orders: OrderIdAndSignatureRequest[] = [];
  userDisplayName: string;
  eSignSelectedForm: FormGroup;
  provider: CredentialedResource;
  popUpTitle: boolean;
  orderCounter: number;

  constructor(
    public stateDate: StateManagementService,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private orderManagementDataService: OrderManagementDataService
  ) {
    this.orders = this.navParams.data.orders;
    this.provider = this.navParams.data.provider;
    this.popUpTitle = this.navParams.data.popUpTitle;
    this.orderCounter = this.navParams.data.orderCounter;
    this.userDisplayName = this.provider.findDisplayName();
    const providerForm = new FormControl(`${this.provider.externalId}`);
    providerForm.disable();
    this.eSignSelectedForm = new FormGroup({
      eSignProvider: providerForm,
      eSignDate: new FormControl(""),
    });
  }

  onDismiss() {
    this.viewCtrl.dismiss({ cancel: true });
  }

  eSignSelectedOrders() {
    this.viewCtrl.dismiss({
      bulkUpdateOrderRequest: this.orderManagementDataService.bulkUpdateOrders(
        this.orders.map((order) => {
          const action: ESignedAction = {
            actionType: Action.ActionTypeEnum.ESigned,
            displayName: this.userDisplayName,
            timezone: moment.tz.guess(),
            eSignatureDate: new Date().toISOString(),
            attestation: true,
            signatureRequests: order.signatureRequests,
          };
          return {
            order: {},
            orderId: order.orderId,
            action: action,
          };
        })
      ),
      cancel: false,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/provider-panel/e-sign-selected-orders/e-sign-selected-orders.ts